import React, { ReactElement } from 'react';
import SearchInput from './SearchInput';
import { useSearchTerm } from '../hooks/useSearchTerm';

const CustomStyles = {
  Search: {
    container: {
      maxWidth: '450px',
      width: '100%',
    }
  }
};

const SearchPanel = (): ReactElement => {
  const { setSearchValue, isSearchActive, setIsSearchActive } = useSearchTerm();

  return (
    <div className="freight-forwarder__search-panel">
      <SearchInput
        name="country"
        placeholder="Search for countries"
        customStyles={CustomStyles.Search}
        setSearchValue={setSearchValue}
        isSearchActive={isSearchActive}
        setIsSearchActive={setIsSearchActive}
      />
    </div>
  );
};

export default SearchPanel;